// extracted by mini-css-extract-plugin
export default {"tabledate":"Table_tabledate__CHJIQ"};